import React from 'react'
import { actions } from 'features/Cart'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import CategoriesHeader from './CategoriesShowcase/CategoriesHeader'
import CategoriesWrapper from './CategoriesShowcase/CategoriesWrapper'
import CategoriesItem from './CategoriesShowcase/CategoriesItem'

import '@loyal_template/showcases.css'

const CategoriesShowcase = ({ onlyCash, showcaseInfos }) => {
  return showcaseInfos.map((item, index) => ((
    <div key={index} className={`bx-categoriesShowcase pos-relative py-3 ${onlyCash ? 'scope-onlyCash' : 'scope-points'}`}>
      <div className='container px-1 px-sm-0'>
        <CategoriesHeader {...item} />
        <CategoriesWrapper>
          {
            item.categories.map((category, categoryIndex) => (
              <CategoriesItem key={categoryIndex} categoryIndex={categoryIndex} name={category.name} path={category.path} />
            ))
          }
        </CategoriesWrapper>
      </div>
    </div>
  )
  ))
}

CategoriesShowcase.propTypes = {
  onlyCash: PropTypes.bool,
  showcaseInfos: PropTypes.object
}
CategoriesShowcase.defaultProps = {
  showcaseInfos: [{
    'title': 'As melhores ofertas por categoria.',
    'titleMobile': 'Categorias',
    'categories': [
      { 'name': 'Smartphones', 'path': '/search?term=Smartphone' },
      { 'name': 'TVs', 'path': '/search?term=TVs' },
      { 'name': 'Notebooks', 'path': '/search?term=Notebooks' },
      { 'name': 'Moda', 'path': '/search?term=Moda' },
      { 'name': 'Esporte e Lazer', 'path': '/search?term=Esporte e Lazer' },
      { 'name': 'Eletrodomésticos', 'path': '/search?term=Eletrodomésticos' }
    ]
  }]
}
const mapStateToProps = ({ onlyCash }) => ({ onlyCash })

const mapDispatchToProps = dispatch => ({
  loadCart: () => dispatch(actions.loadCart())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CategoriesShowcase)



// WEBPACK FOOTER //
// ./src/Catalog/Showcase/CategoriesShowcase.js